module.exports = __webpack_public_path__ + "img/TOPAS_img_2.06a91b8a.png";